import { PdpSharedShippingHolidayDelivery_item as Item } from '../__generated__/PdpSharedShippingHolidayDelivery_item.graphql';
import { PdpSharedShippingHolidayDelivery_viewer as Viewer } from '../__generated__/PdpSharedShippingHolidayDelivery_viewer.graphql';

type ShipmentDeliveryEstimations = NonNullable<Item['holidayShippingEstimations']>;
type ValidHolidayShippingDays = ShipmentDeliveryEstimations['validHolidayShippingDays'];

type ShipmentEstimationMap = {
    [shipmentQuoteId: string]:
        | {
              estimatedDeliveryDay: string;
          }
        | undefined;
};

const getShipmentEstimationMap = (
    validHolidayShippingDays: ValidHolidayShippingDays
): ShipmentEstimationMap => {
    return (validHolidayShippingDays || []).reduce((acc: ShipmentEstimationMap, estimation) => {
        const { shipmentQuoteId, estimatedDeliveryDay } = estimation || {};
        if (shipmentQuoteId && estimatedDeliveryDay) {
            acc[shipmentQuoteId] = { estimatedDeliveryDay };
        }
        return acc;
    }, {});
};

type RelevantShipping = NonNullable<Viewer['relevantShipping']>;
type ShipmentQuotes = NonNullable<RelevantShipping['shipmentQuotes']>;

type ShipmentQuote = NonNullable<ShipmentQuotes[0]>;

type HolidayShippingInfoArgs = {
    shipmentQuotes: ShipmentQuotes;
    validHolidayShippingDays: ValidHolidayShippingDays;
};

type HolidayShippingInfo = {
    estimatedDeliveryDay: string;
    totalAmount: ShipmentQuote['totalAmount'];
    isComplimentary: ShipmentQuote['isComplimentary'];
    buyerServiceMethodDisplay: ShipmentQuote['buyerServiceMethodDisplay'];
}[];

export const getHolidayShippingInfo = ({
    shipmentQuotes,
    validHolidayShippingDays,
}: HolidayShippingInfoArgs): HolidayShippingInfo => {
    const shipmentEstimationMap = getShipmentEstimationMap(validHolidayShippingDays);

    return (shipmentQuotes || []).reduce((acc: HolidayShippingInfo, shipmentQuote) => {
        const {
            serviceId,
            totalAmount = null,
            isComplimentary = null,
            buyerServiceMethodDisplay = null,
        } = shipmentQuote || {};
        const shipmentEstimation = serviceId && shipmentEstimationMap[serviceId];
        const { estimatedDeliveryDay } = shipmentEstimation || {};

        if (shipmentQuote && estimatedDeliveryDay) {
            acc.push({
                totalAmount,
                isComplimentary,
                estimatedDeliveryDay,
                buyerServiceMethodDisplay,
            });
        }
        return acc;
    }, []);
};
